import { Component, OnInit, OnDestroy } from '@angular/core';
import { DevicesDevicesService } from '../../../services/devices-services/devices-devices-services/devices-devices.service';
import { ActivatedRoute } from '@angular/router';
import { DeviceInfo } from 'src/app/models/device-models/device-info-model/device-info.model';
import { DeviceApplication } from 'src/app/models/device-models/device-application-model/device-application.model';
import { EMPTY, Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { DevicePeripheral } from 'src/app/models/device-models/device-peripheral-model/device-peripheral.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-device-dashboard',
  templateUrl: './device-dashboard.component.html',
  styleUrls: ['./device-dashboard.component.scss']
})
export class DeviceDashboardComponent implements OnInit, OnDestroy {

  public deviceInfo: DeviceInfo;
  public deviceApplications: Array<DeviceApplication>;
  public devicePeripherals: Array<DevicePeripheral>;
  public deviceLog: Array<any>;
  public getDeviceInfoSubscripton: Subscription;
  public getDeviceSubscriptionRefresh: Subscription;

  constructor(private devicesService: DevicesDevicesService,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getDeviceInfo();
    this.getDeviceSubscriptionRefresh = this.devicesService.refreshDeviceListen().subscribe(
      (res) => {
        this.getDeviceInfo();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getDeviceInfo() {
    const internalId = this.activatedRoute.snapshot.params['deviceid'];
    this.getDeviceInfoSubscripton = this.devicesService.getDeviceInfo(internalId).pipe(
      tap(o => this.deviceInfo = o.device),
      tap(o => this.deviceApplications = o.deviceApplications),
      tap(o => this.devicePeripherals = o.devicePeripherals),
      tap(o => this.deviceLog = o.deviceLog),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-microchip', 'devices-page.device detail', '/devices', [new BRoute('devices-page.devices', '/devices'), new BRoute('devices-page.device detail')]));
  }

  ngOnDestroy() {
    if (this.getDeviceInfoSubscripton) { this.getDeviceInfoSubscripton.unsubscribe(); }
    if (this.getDeviceSubscriptionRefresh) { this.getDeviceSubscriptionRefresh.unsubscribe(); }
  }

}
